export default __webpack_public_path__ + "static/media/loyalty-icon-redesign.1ce5ff8d.png";